
import React, { createContext, useState, useEffect, useContext } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(() => {
        const saved = localStorage.getItem('theme');
        return saved === 'dark';
    });

    const toggleTheme = () => {
        setIsDarkMode(prev => !prev);
    };

    useEffect(() => {
        localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');

        // Apply class to body for global styles
        if (isDarkMode) {
            document.body.classList.add('dark-mode');
            document.body.style.backgroundColor = '#111827';
        } else {
            document.body.classList.remove('dark-mode');
            document.body.style.backgroundColor = '#f3f4f6';
        }
    }, [isDarkMode]);

    // Define colors for both modes to be used in inline styles
    const colors = {
        background: isDarkMode ? '#111827' : '#f3f4f6', // Gray-900 vs Gray-100
        surface: isDarkMode ? '#1f2937' : '#ffffff',    // Gray-800 vs White
        text: isDarkMode ? '#f9fafb' : '#1f2937',       // Gray-50 vs Gray-800
        textSecondary: isDarkMode ? '#9ca3af' : '#6b7280', // Gray-400 vs Gray-500
        border: isDarkMode ? '#374151' : '#e5e7eb',     // Gray-700 vs Gray-200

        primary: '#3b82f6',                             // Blue-500
        primaryHover: '#2563eb',                        // Blue-600

        danger: '#ef4444',                              // Red-500 (Softer red)
        dangerHover: '#dc2626',                         // Red-600

        // Sidebar specific
        sidebarBg: isDarkMode ? '#111827' : '#ffffff',
        sidebarText: isDarkMode ? '#e5e7eb' : '#374151',
        sidebarHover: isDarkMode ? '#374151' : '#f3f4f6',
        sidebarActive: isDarkMode ? '#1f2937' : '#e5e7eb',
        sidebarBorder: isDarkMode ? '#374151' : '#e5e7eb',
    };

    return (
        <ThemeContext.Provider value={{ isDarkMode, toggleTheme, colors }}>
            {children}
        </ThemeContext.Provider>
    );
};
